import {Stack, Typography, useTheme} from '@mui/material';
import {StyledCard, TagChip} from 'presentation/components';
import {useHostName} from 'presentation/hooks';
import {formatText} from 'presentation/utils';
import React from 'react';
import {useBilletDetails} from '../../hooks/useBilletDetails';

import {translations} from 'presentation/translations-new';

const {billFor, billForNotredameSaude} = translations['pt-br'].privateFlow.myFinancial.billetDetails;

const HeaderCard = () => {
	const {colors, palette} = useTheme();
	const {isNotredameSaude} = useHostName();
	const {formattedTargetDate, chipType, color, chipText} = useBilletDetails();
	return (
		<StyledCard.Container $borderTop $borderColor={color} elevation={0} sx={{mb: '16px'}}>
			<Stack gap={'16px'}>
				<Typography
					fontSize={'0.875rem'}
					fontWeight={600}
					color={colors.light.text.secondary}>
					{isNotredameSaude ? billForNotredameSaude : billFor}
				</Typography>
				<Stack justifyContent="space-between" alignItems="center" direction="row">
					<Typography color={palette.text.primary} variant="h6">
						{formatText(formattedTargetDate)}
					</Typography>

					<TagChip label={chipText} color={chipType} />
				</Stack>
			</Stack>
		</StyledCard.Container>
	);
};

export {HeaderCard};
